import { useCallback, useEffect } from 'react';
import { EventWithTokenizedData, PaymentData, WindowWithPaymentWidget } from './payment.type';
import { useScript } from '../../helpers/hooks';
import { paymentWidgetConfig } from './payment.config';

declare const window: WindowWithPaymentWidget;

type Props = {
  onTokenize: (e: PaymentData) => void;
  isReadyToLoadScript: boolean
}

function usePaymentWidgetScriptLoader({ onTokenize, isReadyToLoadScript }: Props) {
  const loadingStatus = useScript(paymentWidgetConfig.url, {
    removeOnUnmount: true,
    shouldPreventLoad: !isReadyToLoadScript
  });

  const handleToken = useCallback((e: Event) => {
    const tokenEvent = e as EventWithTokenizedData;
    onTokenize(tokenEvent.data);
  }, [onTokenize])

  useEffect(() => {
    if(!isReadyToLoadScript) {
      return;
    }

    if(loadingStatus === 'ready') {
      window.top.addEventListener('token', handleToken, true);
    }

    return () => {
      if(loadingStatus === 'ready') {
        window.top.removeEventListener('token', handleToken, true)
      }
    }
  }, [handleToken, isReadyToLoadScript, loadingStatus]);

  return {}
}

export default usePaymentWidgetScriptLoader;
